export const NEXT_SUGGESTION_TEXT = (attribute?: string) =>
  `You said you ${attribute}. We can help with that.`;
export const NEXT_RESULT_DESCRIPTION = `Try this free challenge and take the first step toward your next step.`;
export const NEXT_GO_TO_APP_BUTTON_TEXT = 'Go To App';
export const NEXT_CHANGE_EMAIL_BUTTON_TEXT = 'Change Email';
